import { addTestRefAtPath, listPathOptions, pathIndicesFromKey } from "./temarioTree";
import { TEMARIO_DEPTH_LABELS } from "../pages/Enlaces_Administracion/Acciones_gc/Cursos_Creacion/editarCursoConstants";

/**
 * @param {Record<string, import("./temarioTree").TemarioNodo[]>} bloquesContenido
 * @param {string} pestanaLabel
 * @param {string} pathKey
 * @param {{ titulo: string, bloque?: string }} testRef
 * @returns {{ ok: true, next: Record<string, import("./temarioTree").TemarioNodo[]> } | { ok: false, error: string }}
 */
export function linkTestToTemarioPath(bloquesContenido, pestanaLabel, pathKey, testRef) {
  const pestana = (pestanaLabel ?? "").trim();
  const titulo = (testRef?.titulo ?? "").trim();
  if (!pestana) {
    return { ok: false, error: "missing_pestana" };
  }
  if (!titulo) {
    return { ok: false, error: "missing_titulo" };
  }
  const path = pathIndicesFromKey(pathKey);
  if (path.length === 0 && pathKey !== "") {
    return { ok: false, error: "invalid_path" };
  }

  const src =
    bloquesContenido && typeof bloquesContenido === "object" ? { ...bloquesContenido } : {};
  const list = Array.isArray(src[pestana]) ? [...src[pestana]] : [];
  const options = listPathOptions(list, TEMARIO_DEPTH_LABELS);
  const validKeys = new Set(options.map((o) => o.pathKey));
  if (pathKey !== "" && !validKeys.has(pathKey)) {
    return { ok: false, error: "invalid_path" };
  }

  const nextList = addTestRefAtPath(list, path, {
    titulo,
    bloque: typeof testRef.bloque === "string" && testRef.bloque.trim() !== "" ? testRef.bloque.trim() : pestana,
  });
  if (!nextList) {
    return { ok: false, error: "already_linked" };
  }

  return {
    ok: true,
    next: {
      ...src,
      [pestana]: nextList,
    },
  };
}

/**
 * @param {Record<string, import("./temarioTree").TemarioNodo[]>} bloquesContenido
 * @param {string} pestanaLabel
 * @param {string} testTitulo
 * @returns {boolean}
 */
export function isTestLinkedInTemario(bloquesContenido, pestanaLabel, testTitulo) {
  const pestana = (pestanaLabel ?? "").trim();
  const titulo = (testTitulo ?? "").trim();
  if (!pestana || !titulo) {
    return false;
  }
  const list = bloquesContenido?.[pestana];
  if (!Array.isArray(list)) {
    return false;
  }
  const walk = (nodes) => {
    for (const node of nodes) {
      if (!node || typeof node !== "object") {
        continue;
      }
      const refs = Array.isArray(node.testRefs) ? node.testRefs : [];
      if (refs.some((ref) => ref && ref.titulo === titulo)) {
        return true;
      }
      const hijos = Array.isArray(node.hijos) ? node.hijos : [];
      if (hijos.length > 0 && walk(hijos)) {
        return true;
      }
    }
    return false;
  };
  return walk(list);
}

/**
 * @param {Record<string, import("./temarioTree").TemarioNodo[]>} bloquesContenido
 * @param {string} testTitulo
 * @returns {boolean}
 */
export function isTestLinkedInAnyTemario(bloquesContenido, testTitulo) {
  const src = bloquesContenido && typeof bloquesContenido === "object" ? bloquesContenido : {};
  return Object.keys(src).some((tab) => isTestLinkedInTemario(src, tab, testTitulo));
}
